// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesInternalDatabaseMetadata
 */
export interface TypesInternalDatabaseMetadata {
  /**
   *
   * @type {string}
   * @memberof TypesInternalDatabaseMetadata
   */
  storeFormat?: string;
}

/**
 * Check if a given object implements the TypesInternalDatabaseMetadata interface.
 */
export function instanceOfTypesInternalDatabaseMetadata(
  value: object,
): value is TypesInternalDatabaseMetadata {
  return true;
}

export function TypesInternalDatabaseMetadataFromJSON(
  json: any,
): TypesInternalDatabaseMetadata {
  return TypesInternalDatabaseMetadataFromJSONTyped(json, false);
}

export function TypesInternalDatabaseMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesInternalDatabaseMetadata {
  if (json == null) {
    return json;
  }
  return {
    storeFormat: json['StoreFormat'] == null ? undefined : json['StoreFormat'],
  };
}

export function TypesInternalDatabaseMetadataToJSON(
  json: any,
): TypesInternalDatabaseMetadata {
  return TypesInternalDatabaseMetadataToJSONTyped(json, false);
}

export function TypesInternalDatabaseMetadataToJSONTyped(
  value?: TypesInternalDatabaseMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    StoreFormat: value['storeFormat'],
  };
}
